import LabelsSettings from './LabelsSettings';

export default LabelsSettings;
